import React, { memo } from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'
import { getAppDisplayName } from '@/utils/appBrand'

function index() {
    const { t } = useTranslation()
    return (
        <div className='cmp-rule'>
            {new Array(7).fill(0).map((_, i) =>
                <span key={i}>{t(`GameRankings.Rule.Rule${i + 1}`, { APP: getAppDisplayName() })}</span>
            )}
        </div>
    )
}

export default memo(index)